import type { FC, ReactNode } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Dropdown, DropdownContent, DropdownItem, DropdownSearch, Skeleton } from "@aviary";
import { l } from "@shared/locales/i18n";
import type { PractitionerType } from "@unauthenticated/shared/data/types";

interface Props {
  designations: PractitionerType[];
  setValue: (value: string) => void;
  hideTooltip?: boolean;
  children: ReactNode;
}

const DesignationDropdown: FC<Props> = ({ designations, setValue, children }) => {
  const [search, setSearch] = useState("");
  const { t } = useTranslation("common");

  const renderItem = (item: PractitionerType) => (
    <DropdownItem key={item.id} onSelect={() => setValue(item.id)}>
      {item.description}
    </DropdownItem>
  );

  const renderItems = () => {
    const items = [...designations]
      .filter(item => {
        if (search) {
          return item.description.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        }
        return true;
      })
      .map(renderItem);
    if (!items.length) {
      return <DropdownItem disabled>{t(l.sharedCatalog.noResults.NoResultsFound)}</DropdownItem>;
    }
    return items;
  };

  if (!designations.length) {
    return <Skeleton type="button" buttonSize="small" isFullwidth />;
  }

  return (
    <Dropdown customDropdownHeight={11} isFullWidth data-e2e="practitioner-type">
      {children}
      <DropdownContent>
        <DropdownSearch
          placeholder={t("Search")}
          onChange={e => setSearch(e.target.value)}
          value={search}
          onCancel={() => setSearch("")}
        ></DropdownSearch>
        {renderItems()}
      </DropdownContent>
    </Dropdown>
  );
};

export { DesignationDropdown };
